export var ConsoleType;
(function (ConsoleType) {
    ConsoleType["XBOX"] = "xbox";
    ConsoleType["PLAYSTATION"] = "playstation";
})(ConsoleType || (ConsoleType = {}));
const RSO_ACCOUNT_LINKING_URL = "https://stage.authenticator.accounts.riotgames.com/login?method=${method}&riot_theme=riot&remember=false&client_id=auth-impl-prod-us-west-2&redirect_uri=";
const RSO_AUTH_REDIRECT_URL = "https://stage.auth.accounts.riotgames.com/authorize?redirect_uri=";
export const generateAccountLinkUrl = (method) => {
    const url = new URL(window.location.href);
    url.searchParams.append(`${method}-linked`, "true");
    return `${RSO_ACCOUNT_LINKING_URL.replace("${method}", method)}${encodeURIComponent(RSO_AUTH_REDIRECT_URL)}${encodeURIComponent(url.toString())}`;
};
export const convertPageLocaleToPlayerLocale = (pageLocale) => {
    const localeRegex = /^[a-z]{2}-[a-z]{2}$/;
    if (!localeRegex.test(pageLocale)) {
        return null;
    }
    const [lang, reg] = pageLocale.split("-");
    const playerLocale = `${lang}_${reg.toUpperCase()}`;
    return playerLocale;
};
//# sourceMappingURL=utils.js.map